<template>
  <div :key="date_input_key">
    <CardedSectionHeader
      icon="mdi-plus"
      label="Change Username Form"
      id="owner_update_username_form_section"
    ></CardedSectionHeader>
    <CardedForm
      ref="owner_update_username_form_ref"
      id="owner_update_username_form"
      title="Update Login UserName"
      :is_loading="is_loading"
      @on-submit-form="submit"
      :errors="errors"
      :message="message"
      @on-auto-fill="on_auto_fill"
      @on-close-message="on_hide_message"
      @on-clear-form="on_clear_form"
    >
      <TextField
        v-model="form.current_email"
        :validation_rules="email_rules"
        label="Current E-mail Address/ Phone Number  (This is your user name)"
        icon="mdi-email-variant"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="form.new_email"
        :validation_rules="email_rules"
        label="New E-mail Address/ Phone Number  (new login user name)"
        icon="mdi-email-variant"
        :disabled="is_loading"
      ></TextField>

      <TextField
        v-model="form.current_password"
        :validation_rules="password_rules"
        label="Current Password"
        type="password"
        icon="mdi-key-variant"
        :disabled="is_loading"
      ></TextField>
    </CardedForm>
  </div>
</template>


<script>
import TextField from "../../../components/TextField";
import CardedForm from "../../../components/CardedForm";
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import Utils from "../../../lib/Utils";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "OwnerSecurityUsername",
  components: {
    TextField,
    CardedForm,
    CardedSectionHeader,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      _user: null,
      errors: [],
      message: "",
      form: {
        current_email: "",
        new_email: "",
        current_password: "",
      },
      email_rules: [
        Utils.validate.is_required("Email address or Phone number is required"),
        Utils.validate.email_format_or_phone(
          "Invalid input, must be a valid email address or a valid phone number"
        ),
      ],
      password_rules: [
        Utils.validate.is_required("Password is required"),
        Utils.validate.min_max_length(
          6,
          10,
          "Password should be between 6 and 10 characters"
        ),
      ],
      date_input_key: "owner_username_key_1",
      date_input_key_truck: 1,
      email_used: ""
    };
  },
  methods: {
    on_auto_fill() {
      this.ini_form();
    },
    on_clear_form() {
      this.ini_form();
    },
    ini_form() {
      this.form.current_email = "";
      this.form.new_email = "";
      this.form.current_password = "";
      this.date_input_key_truck = this.date_input_key_truck + 1;
      this.date_input_key = "owner_username_key_" + this.date_input_key_truck;
    },
    submit() {
      this.email_used = this.form.new_email;
      this.errors = [];
      this.message = "";

      this.$emit("on-show-loader");
      ServerClient.Security.update_username(
        {
          ...this.form,
          user_id: this._user.id,
          email: this._user.email,
        },
        (res) => {
          this.$emit("on-hide-loader");

          var msg =
            "<b>User name update was succesfull</b> <br/>  Please verify your new account. ";
          if (this.email_used.indexOf("@") > 0) {
            msg =
              msg +
              " <br/><br/> <b class='success--text'>Please check your email " +
              this.email_used +
              " for an activation link</b>";
          } else {
            msg =
              msg +
              " <br/><br/> <b class='success--text'>Please check your phone " +
              this.email_used +
              " for an sms with the activation code</b>";
          }
          this.message = msg;

          this.$refs.owner_update_username_form_ref.show_message_dialog();
        },
        (errors) => {
          this.$emit("on-hide-loader");
          this.errors = errors;
          this.$refs.owner_update_username_form_ref.show_error_dialog();
        }
      );
    },
    on_hide_message() {
      ServerClient.Login.logout((res) => {
        this._user = null;
        if (this.email_used.indexOf("@") > 0) {
          this.$router.push("/");
          this.$router.go(0); //force it to refresh
        } else {
          this.$router.push("/activate");
          this.$router.go(0); //force it to refresh
        }
      });
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();

    this.$emit("set-page-attributes", {
      title: "Security User Name Management",
      crumps: [
        {
          text: "Owner",
          disabled: false,
          href: "/owner",
        },
        {
          text: "Security",
          disabled: false,
          href: "/owner/security",
        },
        {
          text: "Username",
          disabled: true,
          href: "/owner/security/username/update",
        },
      ],
    });

    this.ini_form();
  },
};
</script>